import React from "react";
import LegalPolicyRedirect from "./LegalPolicyRedirect";
export default function PrivacyPolicy() { return <LegalPolicyRedirect policy="privacy" />; }
